import {IEmpProfDetails,ISingleEmployProfActionTypes,ISingleEmployProfActionCreator} from 'models/ISingleEmpProfDetails';

const initialState:IEmpProfDetails = {
    id: 0,
    employee_id: '',
    project: {},
    sub_projects: [],
    work_types: [],
    leads: [],
    work_location: {},
    skill_sets: [],
    access_level: '',
    employee_module_access_levels: []
}

const reducer = (state = initialState, { type, payload }: ISingleEmployProfActionCreator) => {
    switch (type) {
      case ISingleEmployProfActionTypes.FETCH_EMP_PROF_DETAILS_LIST_REQUEST:
        return {
          ...state,
          data:{},
        }
      case ISingleEmployProfActionTypes.FETCH_EMP_PROF_DETAILS_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;